export const HABU_GPG_PUBLIC_KEY = {
  source: 'HABU',
  keyName: 'HABU_PUBLICKEY',
};

export const CLIENT_GPG_PUBLIC_KEY = {
  source: 'CLIENT',
  keyName: 'CLIENT_PUBLICKEY',
};
